import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  // templateUrl: './app.component.html',
  template: '<p-toast styleClass="custom-toast" ></p-toast><router-outlet></router-outlet>',
  // styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Capacitacion_Web';
  constructor(){
    console.log("llego hasta aqui");
  }
}
